import React, { useCallback } from 'react';
import {
  Image, mergeClasses, Caption1Strong, Spinner, Checkbox,
} from '@fluentui/react-components';

import { Theme } from './types';
import { useThemeCellStyles } from './useThemeCellStyles.styles';

import defaultImage from '../../images/DefaultImage';

export interface ThemeCellProps {
  disabled?: boolean;
  theme: Theme;
  onSelect: () => void;
}

export const ThemeCell: React.FC<ThemeCellProps> = (props) => {
  const { disabled, theme, onSelect } = props;

  const classes = useThemeCellStyles();

  const [loaded, setLoaded] = React.useState(false);

  const handleKeyUp = useCallback((event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (!disabled && (event.key === 'Enter' || event.key === ' ')) {
      onSelect();
    }
  }, [disabled, onSelect]);

  return (
    <label
      htmlFor={theme.RecommendationId}
      className={mergeClasses(classes.root, theme.IsSelected && classes.rootSelected, classes.indicator)}
      tabIndex={0}
      aria-disabled={disabled}
      onKeyUp={handleKeyUp}
    >
      <Checkbox
        id={theme.RecommendationId}
        className={mergeClasses('theme-cell-checkbox', classes.checkbox)}
        size="large"
        tabIndex={-1}
        aria-label={theme.Name}
        checked={!!theme.IsSelected}
        onChange={onSelect}
        disabled={disabled}
        indicator={{
          className: 'theme-cell-checkbox-indicator',
        }}
      />
      <div className={classes.labelContainer}>
        <Caption1Strong className={classes.label}>
          {theme.Name}
        </Caption1Strong>
      </div>
      {!loaded && (
      <div className={classes.spinnerContainer}>
        <Spinner />
      </div>
      )}
      <Image
        alt={theme.Name}
        fit="cover"
        src={theme.Images[0]?.Url || defaultImage}
        onLoad={() => setLoaded(true)}
      />
    </label>
  );
};
